import styled from 'styled-components';

export const TopSummaryLineWrapper = styled.div`
  display: flex;
  margin-bottom: 46px;

  @media (max-width: 638px) {
    margin-inline-start: 20px;
    margin-bottom: 34px;
    justify-content: center;
  }
`;

export const ContentTypePillWrapper = styled.div`
  font-weight: 700;
  margin-inline-end: 32px;

  @media (max-width: 638px) {
    margin-inline-end: 10px;
  }

  [class*='Pillstyle__Pill-sc'] {
    height: 26px;
    display: block;
    padding: 4px 16px;
  }
`;

export const DateIconWrapper = styled.div`
  display: flex;
  align-items: center;

  > span {
    margin-inline-end: 4px;
  }
`;

export const DateTextWrapper = styled.div`
  font-size: 18px;
  line-height: 26px;
  text-wrap: nowrap;
`;

export const ReadingTimeTooltipWrapper = styled.div`
  #reading-time-tooltip {
    max-width: 278px;

    > div {
      margin: 0;

      > p {
        margin: 0 !important;
      }
    }
  }
`;

export const ReadingTimeContainer = styled.div`
  display: flex;
  font-size: 18px;
  line-height: 26px;
  text-wrap: nowrap;
  align-items: center;
  margin: 0 20px;
`;

export const ReadingTimeTextWrapper = styled.div`
  margin-inline: 0 4px;

  @media (max-width: 638px) {
    margin-inline: 4px 0;
  }
`;

export const SummaryCardWrapper = styled.div`
  background-color: #fff;
  border: 1px solid #000;
  border-radius: 6px;
  padding: 20px 40px;

  @media (max-width: 638px) {
    padding: 20px 14px 8px 14px;
  }
`;

export const HeaderWrapper = styled.div`
  margin-bottom: 14px;

  > h2:first-child {
    margin-top: 0;
    font-size: 24px;
    line-height: 44px;
    font-weight: 700 !important;

    @media (max-width: 638px) {
      font-size: 16px;
      line-height: 20px;
    }
  }
`;

export const SummaryContentWrapper = styled.div`
  @media (max-width: 638px) {
    margin-inline-start: 4px;
  }
`;

export const SummaryItemContainer = styled.div`
  display: flex;
  cursor: pointer;
  margin: 4px 0;
  align-items: baseline;
`;

export const SummaryItemIconWrapper = styled.div`
  margin-inline-end: 14px;

  svg {
    width: 29px;
    height: 29px;

    path {
      fill: #e60000;
    }

    @media (max-width: 638px) {
      width: 21px;
      height: 21px;
    }
  }
`;

export const SummaryItemTextWrapper = styled.div`
  font-size: 20px;
  line-height: 32px;

  @media (max-width: 638px) {
    font-size: 14px;
    line-height: 18px;
  }
`;
